
import { trackPageView as gaTrackPageView } from '../../../default/analytics'
import { trackPageView as gtmTrackPageView } from '../../../default/google_tag_manager'

export function trackHotelOverview (hotel) {
  gaTrackPageView(`${window.location.pathname}#${hotel.id}`)
  gtmTrackPageView(`${window.location.pathname}#${hotel.id}`)
}

export function trackHotelIndex(){
  gaTrackPageView(window.location.pathname)
  gtmTrackPageView(window.location.pathname)
}
